module.exports = __webpack_public_path__ + "static/media/heroBack2.3f8fbe82.svg";